import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreferencesComponent } from './pages';
import { NotificationsRouteConfig } from './notifications-route-config';
import { UserPreferencesResolver } from './resolvers/user-preferences.resolver';

const routes: Routes = [
  {
    path: 'update-preferences',
    component: PreferencesComponent,
    resolve: {
      userPrefs: UserPreferencesResolver
    },
    data: { routeConfig: NotificationsRouteConfig }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationPrefsRoutingModule {}
